import type { IHelpCenterCategories } from '@/storyblok/PageHelpCenterHome';
import type { TFunction } from 'i18next';

export function generateFaqHeadline(
  t: TFunction<'translation', undefined>,
  storySlug: string,
  categories: IHelpCenterCategories[]
) {
  const categorySlug = storySlug.split('/').slice(0, -1).join('/');
  const selectedCategory = categories.find((category) => category.link === `/${categorySlug}/`);
  const faqTopic = selectedCategory?.title || '';

  return t('helpCenter.furtherContentOn', { topic: faqTopic });
}

export function generateFaqOverviewHeadline(t: TFunction<'translation', undefined>, topicTitle: string | undefined) {
  return t('helpCenter.frequentlyAskedQuestionsOn', { topic: topicTitle || '' });
}
